import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";


function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://api.itosoba.ru/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {
        const data = await response.json();
        const token = data.token;
        setToken(token);

        const decoded = jwtDecode(token);
        const role = decoded.role; 

        if (role === 'Admin') {
          localStorage.setItem('role', role);
          navigate('/admin');
        } else {
          setError('Доступ запрещён: недостаточные права');
        }
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Ошибка входа');
        setToken('');
      }
    } catch (err) {
      setError('Произошла ошибка при подключении');
    }
  };

  return (
    <div>
      <h2>Вход в админку</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label style={{ marginRight: 10 }}>Логин:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Пароль:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Войти</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {token && <p style={{ color: 'green' }}>Успешный вход! Токен: {token}</p>}
    </div>
  );
}

export default AdminLogin;